<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-redo`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.45166 4.28906C8.68867 4.28906 10.5401 5.29374 12.0278 6.47852C12.9298 7.19683 13.7359 8.01816 14.4214 8.74219V6.75977C14.4214 6.3925 14.7192 6.09473 15.0864 6.09473C15.4537 6.09473 15.7515 6.3925 15.7515 6.75977V10.3789C15.7515 10.3835 15.7496 10.388 15.7495 10.3926C15.7532 10.5683 15.6897 10.7454 15.5552 10.8789C15.3792 11.0533 15.1307 11.1061 14.9077 11.0439H11.5542C11.1871 11.0439 10.8894 10.7459 10.8892 10.3789C10.8892 10.0116 11.1869 9.71387 11.5542 9.71387H13.5073C12.8306 8.99557 12.0787 8.2196 11.1997 7.51953C9.83469 6.43246 8.26997 5.61914 6.45166 5.61914C4.61783 5.61916 3.4347 6.31468 2.69092 7.29102C1.92689 8.29414 1.57861 9.66026 1.57861 11.0449C1.57842 11.412 1.28065 11.7099 0.913574 11.71C0.546424 11.71 0.248728 11.412 0.248535 11.0449C0.248535 9.46481 0.6414 7.78527 1.63232 6.48438C2.6438 5.15665 4.23009 4.28908 6.45166 4.28906Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineRedo',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
